/** Positive feedback option translation keys */
export const POSITIVE_OPTION_KEYS = [
  'automation.quillChat.feedback.positive.accurate',
  'automation.quillChat.feedback.positive.savedTime',
  'automation.quillChat.feedback.positive.clearReasoning',
  'automation.quillChat.feedback.positive.handledComplexity',
  'automation.quillChat.feedback.positive.matchedIntent',
  'automation.quillChat.feedback.other',
] as const;

/** Negative feedback option translation keys */
export const NEGATIVE_OPTION_KEYS = [
  'automation.quillChat.feedback.negative.incorrectResult',
  'automation.quillChat.feedback.negative.tookTooLong',
  'automation.quillChat.feedback.negative.unclearReasoning',
  'automation.quillChat.feedback.negative.didntHandleEdgeCase',
  'automation.quillChat.feedback.negative.didntMatchIntent',
  'automation.quillChat.feedback.other',
] as const;
